import PropTypes from 'prop-types'

const LayoutHome = (props) => {
  const { modifiers } = props
  const modifierClasses = modifiers && modifiers.length ? ' ' + modifiers.join(' ') : ''

  return (
    <>
      <div className={`LayoutHome${modifierClasses}`}>
        <div className="LayoutHome-inner">
          {props.headerContent && <div className="LayoutHome-header">{props.headerContent}</div>}
          <main className="LayoutHome-main">
            <div className="LayoutHome-mainContent">{props.mainContent}</div>
            {props.footerContent && (
              <div className="LayoutHome-mainFooter">
                <div className="LayoutHome-footerContent">{props.footerContent}</div>
              </div>
            )}
          </main>
        </div>
      </div>
    </>
  )
}

LayoutHome.propTypes = {
  modifiers: PropTypes.array,
  headerContent: PropTypes.shape({}),
  mainContent: PropTypes.shape({}),
  footerContent: PropTypes.shape({})
}

export default LayoutHome
